import React from 'react';

export default props => {
    const {children,...others} = props;
    return <label className="bx--label" {...others}>{children}</label>
}
